import * as React from 'react';
import { NotificationType } from 'models/ApiEnums';
import { useTranslation } from 'react-i18next';

const NotificationTypeName: React.FC<{ notificationType: NotificationType; }> = (props) => {
    const { t } = useTranslation("sys");
    return <span>{t(`NotificationType.${NotificationType[props.notificationType]}`)}</span>;
};

export default NotificationTypeName;